import { UserOutlined } from "@ant-design/icons";
import { Avatar, Comment, Tooltip, Icon } from "antd";
import HtmlText from "../html-text/HtmlText";
import React from "react";
import "./CustomComment.scss";
import moment from "moment";

const CustomComment = ({
  author,
  avatarSrc = "",
  comment = "",
  date,
  isSender = false,
  actions = [],
  title = ""
}) => {
  return (
    <div className="custom-comment">
      <Comment
        style={{
          backgroundColor: isSender ? "rgba(170, 169, 169, 0.1)" : "#E5F1FD",
        }}
        actions={actions}
        author={author}
        avatar={
          <Avatar
            src={avatarSrc ? avatarSrc : ""}
            icon={<UserOutlined />}
            shape="square"
          />
        }
        content={<HtmlText htmlText={comment}/>}
        datetime={
          <>
          <span className="publish-time">{moment(date).format("DD-MM-YYYY hh:mm A")}</span>
          <Tooltip className="comment-label-tooltip" title={`Proceso original: ${title}`}>
            <Icon type="info-circle" />
          </Tooltip>
          </>
        }
      />
    </div>
  );
};

export default CustomComment;
